import React from 'react';
import { useRBAC } from '../contexts/RBACContext';
import { Box, Typography, Container } from '@mui/material';
import { PiLock } from 'react-icons/pi';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { isAdmin, loading } = useRBAC();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Typography>Loading permissions...</Typography>
      </Box>
    );
  }

  if (!isAdmin()) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}><PiLock size={80} style={{ opacity: 0.54 }} /></Box>
        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary">
          You need administrator privileges to access this page.
        </Typography>
      </Container>
    );
  }

  return <>{children}</>;
}